import React, { useContext } from 'react'
import styled from '@emotion/styled'
import { Link } from 'gatsby'
import { keyframes } from '@emotion/core'
import ThemeContext from '@/context/Theme'
import { tablet, mobile } from '@/utils/media'
import { mq, rem } from '@/utils/helpers'
import { easing } from '@/utils/preset'

const Component = props => {
  const { children, to, href, target, as, hideArrow = false } = props
  const { theme } = useContext(ThemeContext)
  const Root = typeof as !== 'undefined' ? Button(as) : Button(Link)

  return (
    <Root {...props} theme={theme} target={target} to={to} href={href} as={as} >
      <Button_Content>
        <Button_Text><span>{children}</span></Button_Text>
        {!hideArrow && (
          <Button_Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.21 10.06" fill="currentColor">
            <path d="M3.47094 5.03006L0.000937462 10.0601L10.2109 5.03006L0.000936582 5.90667e-05L3.47094 5.03006Z" fill="currentColor"/>
          </Button_Icon>
        )}
      </Button_Content>
    </Root>
  )
}

const anim = {
  button: {
    color: (color1, color2) => keyframes({
      '50%': {
        color: color1
      },
      '100%': {
        color: color2
      },
      label: 'button-color'
    }),
    before: keyframes({
      '50%': {
        transform: 'translateX(100%)'
      },
      '100%': {
        transform: 'translateX(100%)'
      },
      label: 'button-after'
    }),
    after: keyframes({
      '0%': {
        transform: 'translateX(-100%)'
      },
      '50%': {
        transform: 'translateX(-100%)'
      },
      '100%': {
        transform: 'translateX(0%)'
      },
      label: 'button-after'
    })
  }
}

const Button = styled.div`
  margin: 0 auto;
  position: relative;
  display: block;
  width: ${rem(420)};
  max-width: 100%;
  height: ${rem(58)};
  overflow: hidden;
  color: ${props => props.theme.primary.exdark};
  background-color: ${props => props.theme.primary.exdark};
  border: 1px solid ${props => props.theme.primary.exdark};
  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
  }
  &:after {
    transform: translateX(-100%);
  }
  @media (hover: hover), (-ms-high-contrast: none) {
    &:hover {
      animation: ${props => anim.button.color(props.theme.primary.contrast.exdark, props.theme.primary.exdark)} 0.5s ${easing.css.easeInOutExpo};
    }
    &:hover:before {
      animation: ${anim.button.before} 0.5s ${easing.css.easeInOutExpo};
    }
    &:hover:after {
      animation: ${anim.button.after} 0.5s ${easing.css.easeInOutExpo};
    }
  }
`.withComponent

const Button_Content = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: ${rem(18)};
  @media ${mq.and(mobile)} {
    font-size: ${rem(14)};
  }
`

const Button_Icon = styled.svg`
  position: absolute;
  top: 50%;
  right: ${rem(22)};
  width: ${rem(17)};
  height: ${rem(17)};
  transform: translateY(-50%);
  @media ${mq.and(tablet, mobile)} {
    right: ${rem(12)};
    width: ${rem(10.2132)};
    height: ${rem(10.06)};
  }
`

const Button_Text = styled.span`
  transform: translateY(-10%);
  font-weight: bold;
`

export default Component
